import { usePostHog } from "posthog-js/react";

interface BaseEventProps {
  [key: string]: unknown;
}

export const EVENT_TYPE = {
  USER_SIGNED_UP: "user_signed_up",
  USER_SIGNED_IN: "user_signed_in",
  USER_SIGNED_OUT: "user_signed_out",

  CALENDAR_CONNECTED: "calendar_connected",
  CALENDAR_DISCONNECTED: "calendar_disconnected",
  CALENDAR_SYNCED: "calendar_synced",
  CALENDAR_TOGGLED: "calendar_toggled",

  PREFERENCES_UPDATED: "preferences_updated",

  FOCUS_TIME_ALLOCATED: "focus_time_allocated",

  BUTTON_CLICKED: "button_clicked",
} as const;

interface TrackEvent {
  USER_SIGNED_UP: (method: "email" | "google", props?: BaseEventProps) => void;
  USER_SIGNED_IN: (method: "email" | "google", props?: BaseEventProps) => void;
  USER_SIGNED_OUT: (props?: BaseEventProps) => void;
  CALENDAR_CONNECTED: (provider: string, props?: BaseEventProps) => void;
  CALENDAR_DISCONNECTED: (provider: string, calendar_id: string, props?: BaseEventProps) => void;
  CALENDAR_SYNCED: (props?: BaseEventProps) => void;
  CALENDAR_TOGGLED: (calendar_id: string, enabled: boolean, props?: BaseEventProps) => void;
  PREFERENCES_UPDATED: (props?: BaseEventProps) => void;
  FOCUS_TIME_ALLOCATED: (blocks_count: number, total_minutes: number, props?: BaseEventProps) => void;
  BUTTON_CLICKED: (props?: BaseEventProps) => void;
}

export const useAnalytics = () => {
  const posthog = usePostHog();

  const TRACK: TrackEvent = {
    USER_SIGNED_UP: (method, props) => posthog?.capture(EVENT_TYPE.USER_SIGNED_UP, { method, ...props }),

    USER_SIGNED_IN: (method, props) => posthog?.capture(EVENT_TYPE.USER_SIGNED_IN, { method, ...props }),

    USER_SIGNED_OUT: (props) => posthog?.capture(EVENT_TYPE.USER_SIGNED_OUT, props),

    CALENDAR_CONNECTED: (provider, props) => posthog?.capture(EVENT_TYPE.CALENDAR_CONNECTED, { provider, ...props }),

    CALENDAR_DISCONNECTED: (provider, calendar_id, props) =>
      posthog?.capture(EVENT_TYPE.CALENDAR_DISCONNECTED, { provider, calendar_id, ...props }),

    CALENDAR_SYNCED: (props) => posthog?.capture(EVENT_TYPE.CALENDAR_SYNCED, props),

    CALENDAR_TOGGLED: (calendar_id, enabled, props) =>
      posthog?.capture(EVENT_TYPE.CALENDAR_TOGGLED, { calendar_id, enabled, ...props }),

    PREFERENCES_UPDATED: (props) =>
      posthog?.capture(EVENT_TYPE.PREFERENCES_UPDATED, {
        ...props,
      }),

    FOCUS_TIME_ALLOCATED: (blocks_count, total_minutes, props) =>
      posthog?.capture(EVENT_TYPE.FOCUS_TIME_ALLOCATED, {
        blocks_count,
        total_minutes,
        ...props,
      }),

    BUTTON_CLICKED: (props) => posthog?.capture(EVENT_TYPE.BUTTON_CLICKED, props),
  };

  return TRACK;
};
